const loading = theme => ({
	loading: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: 'center',
		paddingTop: 10,
		paddingBottom: 10
	},
})


export default loading